import request from '../request'

export function fetchStampReviewDetail(id) {
    return request({
        url: `/project-service/cosys/stamp/detail/${id}`,
        method: 'GET'
    })
}

export function resubmitStampReview(data) {
    return request({
        url: `/project-service/cosys/stamp/resubmit`,
        method: 'POST',
        data
    })
}



/**
 * 查询待签章详情
 * @param {String} id - 待签章记录ID
 */
export function getDesignStampDetail(id) {
    return request({
        url: `/project-service/cosys/design/stamp/detail/${id}`,
        method: 'GET'
    })
}


/**
 * 重新申请签章（仅Reject/Cancel状态可操作）
 * @param {Object} data - 签章申请数据
 */
export function resubmitDesignStamp(data) {
    return request({
        url: '/project-service/cosys/design/stamp/resubmit',
        method: 'POST',
        data
    })
}

/**
 * 查询签章列表
 * @param {Object} params - 查询参数
 */
export function getStampList(params) {
    return request({
        url: '/project-service/cosys/stamp/list',
        method: 'GET',
        params
    })
}
